import { render, staticRenderFns } from "./KetersediaanPelayanan.vue?vue&type=template&id=d55c39f6"
import script from "./KetersediaanPelayanan.vue?vue&type=script&lang=js"
export * from "./KetersediaanPelayanan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\Work\\laporan-rl\\sembiring_rekammedis\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d55c39f6')) {
      api.createRecord('d55c39f6', component.options)
    } else {
      api.reload('d55c39f6', component.options)
    }
    module.hot.accept("./KetersediaanPelayanan.vue?vue&type=template&id=d55c39f6", function () {
      api.rerender('d55c39f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/app/rlexternal/identitas-rumah-sakit/KetersediaanPelayanan.vue"
export default component.exports